exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Course.scss?vue&type=style&index=0&id=3d6fedc4&prod&lang=scss&scoped=true&external","sourceRoot":""}]);

// exports
